<!-- step-form-2.component.html -->
<form [formGroup]="FormGroup2" class="step2-form">
    <div formArrayName="ACPN_LIST" class="acomp-container">
        <div *ngFor="let acompanhante of acompanhantesFA.controls; let i = index" [formGroupName]="i"
            class="acomp-card">
            <div class="acomp-grid">
                <app-input [disabled]="isView" type="text" name="nomeAcompanhante{{i}}" formControlName="NM_ACPN"
                    label="Nome Completo" placeholder="Digite o nome completo"
                    [style]="{'width': '100%'}">
                </app-input>

                <div class="input">
                    <label>
                        Vínculo com o Motorista 
                    </label>

                    <select [disabled]="true" style="width: 100%" formControlName="NU_VNCL_MTRT"
                        (change)="normalizeVinculo(i)">
                        <option [ngValue]="null">Selecione</option>
                        <option *ngFor="let data of vinculosOptions" [ngValue]="data.value">
                            {{ data.name }}
                        </option>
                    </select>
                </div>

                <app-input [disabled]="isView" type="date" name="dataNascimento{{i}}" formControlName="DT_NASC"
                     width="100%" label="Data de Nascimento" [selectData]="vinculosOptions"
                    [adultOnly]="true" [minAgeYears]="18">
                </app-input>

                <app-input type="text" name="TX_DOC_VNCL{{i}}" formControlName="TX_DOC_VNCL" label="Anexo Comprobatório"
                    placeholder="Informe o documento" [style]="{'width': '100%'}">
                </app-input>

            </div>
            @if(i >= 0) {
            <img class="btn-img" [class.disabled]="isView || acompanhantesFA.length <= 1" src="assets/trashcan2.png"
                width="32" height="32" alt="Remover Acompanhante" (click)="removeAcompanhante(i)">
            }
        </div>
    </div>

</form>
<div class="add-button-container">
    <button type="button" class="add-btn" (click)="addAcompanhante()" [disabled]="isView">
        <span class="plus-icon">+</span>
    </button>
</div>